import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Swal from 'sweetalert2'; // Added Swal for notifications
import { BiensImmobs } from 'app/models/biensImmobs';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { BiensImmobsBiensImmobs } from 'app/services/biens-immobs/biens-immobs.service';
import { AwscontrolService, UploadResponse } from 'app/services/aws/awscontrol.service'; // Import AWS service

@Component({
  selector: 'app-ajouter-bienimmob',
  templateUrl: './ajouter-bienimmob.component.html',
  styleUrls: ['./ajouter-bienimmob.component.scss']
})
export class AjouterBienimmobComponent implements OnInit {

  nameErrorMessage: string = '';
  selectedFiles: FileList;
  selectedPromoFiles: FileList; // Added separate variable for promo files

  fileNames: any = [];
  formData = {
    videoUrl: ''
  };
  photourl!: string;
  allAttch: any[] = [];
  promoAttch: any[] = []; // Added separate array for promo images

  public image!: string;
  public imagePromo!: string;
  agenciesApp: any;
  biensImmob: BiensImmobs;
  public biens: any;
  NameAgence: any;
  idItem: any;
  idA: any;
  NameAgence1: any;

  constructor(
    private router: Router,
    private location: Location,
    private agenciesService: AgenciesService,
    private bienImmobService: BiensImmobsBiensImmobs,
    private awsService: AwscontrolService // Inject AWS service
  ) { 
    this.biensImmob = new BiensImmobs();
    this.selectedFiles = null!;
    this.selectedPromoFiles = null!;
  }

  ngOnInit(): void {
    this.clearStoredImages();
    this.retrieveStoredItemId();
    this.getData();
    this.agenciesService.getId().subscribe((data: any) => {
      this.idA = data;
      console.log('this is my data', this.idA);
    });
    
    console.log('testtesttesttesttesttesttesttesttesttesttesttesttesttest', this.idA);
    this.AgencyNameById();
  }

  // Generate random string for file names
  public getRandomString(length: any): string {
    const randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
      result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
    }
    return result;
  }

  // Upload main images
  uploadimg2(): void {
    if (this.selectedFiles && this.selectedFiles.length > 0) {
      // Convert FileList to array
      const filesArray: File[] = [];
      for (let i = 0; i < this.selectedFiles.length; i++) {
        filesArray.push(this.selectedFiles[i]);
      }
      
      this.uploadFilesimg2(filesArray);
    }
  }

  selectFileimg(e: any): void {
    this.selectedFiles = e.target.files;
    this.uploadimg2();
  }

  uploadFilesimg2(files: File[]): void {
    // Generate unique file names
    const renamedFiles = files.map(file => {
      const newName = `${this.getRandomString(5)}_${file.name}`;
      return new File([file], newName, { type: file.type });
    });

    this.awsService.uploadFiles(renamedFiles, 'bien-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success) {
          console.log('Images uploaded:', response.urls);
          
          // Add all uploaded URLs to array
          response.urls.forEach(url => {
            this.allAttch.push(url);
            this.fileNames.push(url); // Store URLs instead of original file names
          });
          
          // Store in localStorage (first image)
          if (this.allAttch.length > 0) {
            localStorage.setItem('bienImage', JSON.stringify(this.allAttch[0]));
            this.image = this.allAttch[0];
          }
          
          Swal.fire({
            icon: "success",
            title: "Images ajoutées",
            text: `${response.count} image(s) téléchargée(s) avec succès`,
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement des images",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading images:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement des images. Veuillez réessayer.",
        });
      }
    });
  }

  // Upload promo image
  uploadimgPromo(): void {
    if (this.selectedPromoFiles && this.selectedPromoFiles.length > 0) {
      const file = this.selectedPromoFiles[0];
      this.uploadFileimgPromo(file);
    }
  }

  selectFileimgPromo(e: any): void {
    this.selectedPromoFiles = e.target.files;
    this.uploadimgPromo();
  }

  uploadFileimgPromo(file: File): void {
    // Generate unique file name
    const renamedFile = new File([file], `${this.getRandomString(5)}_${file.name}`, { 
      type: file.type 
    });

    this.awsService.uploadFile(renamedFile, 'bien-promo-images').subscribe({
      next: (response: UploadResponse) => {
        if (response.success && response.urls.length > 0) {
          console.log('Promo image uploaded:', response.urls[0]);
          
          // Store in localStorage
          localStorage.setItem('promoBien', JSON.stringify(response.urls[0]));
          
          // Update local variables
          this.promoAttch = [response.urls[0]];
          this.imagePromo = response.urls[0];
          
          Swal.fire({
            icon: "success",
            title: "Image promotionnelle ajoutée",
            text: "L'image promotionnelle a été téléchargée avec succès",
            timer: 2000,
            showConfirmButton: false
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Erreur de téléchargement",
            text: response.error || "Échec du téléchargement de l'image promotionnelle",
          });
        }
      },
      error: (err: any) => {
        console.error('Error uploading promo image:', err);
        Swal.fire({
          icon: "error",
          title: "Erreur de téléchargement",
          text: "Échec du téléchargement de l'image promotionnelle.",
        });
      }
    });
  }

  // Clear stored images
  clearStoredImages(): void {
    localStorage.removeItem('bienImage');
    localStorage.removeItem('promoBien');
    this.allAttch = [];
    this.promoAttch = [];
    this.image = '';
    this.imagePromo = '';
  }

  // Remove main image
  removeImage(index: number): void {
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer cette image?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.allAttch.splice(index, 1);
        this.fileNames.splice(index, 1);
        
        // Update localStorage with first image or clear if empty
        if (this.allAttch.length > 0) {
          localStorage.setItem('bienImage', JSON.stringify(this.allAttch[0]));
          this.image = this.allAttch[0];
        } else {
          localStorage.removeItem('bienImage');
          this.image = '';
        }
        
        Swal.fire({
          icon: "success",
          title: "Image supprimée",
          text: "L'image a été supprimée avec succès",
          timer: 2000,
          showConfirmButton: false
        });
      }
    });
  }

  // Remove promo image
  removePromoImage(): void {
    Swal.fire({
      title: 'Êtes-vous sûr?',
      text: "Voulez-vous vraiment supprimer l'image promotionnelle?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#f44336',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Oui, supprimer!',
      cancelButtonText: 'Annuler'
    }).then((result) => {
      if (result.isConfirmed) {
        this.promoAttch = [];
        this.imagePromo = '';
        localStorage.removeItem('promoBien');
        
        Swal.fire({
          icon: "success",
          title: "Image supprimée",
          text: "L'image promotionnelle a été supprimée avec succès",
          timer: 2000,
          showConfirmButton: false
        });
      }
    });
  }

  getData(): void {
    this.getAllAgencies();
  }

  getAllAgencies(): void {
    this.agenciesService.getList().subscribe((data) => {
      this.agenciesApp = data;
    });
  }

  csvInputChange(fileInputEvent: any): void {
    console.log(fileInputEvent.target.files[0]);
  }

  csvInputtChange(fileInputEvent: any): void {
    console.log(fileInputEvent.target.files[0]);
  }

  onSubmit(): void {
    // Validation
    if (!this.validateForm()) {
      return;
    }

    if (!this.biensImmob.name || !this.biensImmob.description || !this.biensImmob.agencyName) {
      Swal.fire({
        icon: 'warning',
        title: 'Champs requis',
        text: 'Veuillez remplir tous les champs obligatoires (Nom, Description, Agence)'
      });
      return;
    }

    if (this.biensImmob.videoUrlBien && !this.validateVideoUrl()) {
      Swal.fire({
        icon: 'error',
        title: 'URL YouTube invalide',
        text: 'Veuillez entrer une URL YouTube valide'
      });
      return;
    }

    if (this.allAttch.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Image requise',
        text: 'Veuillez ajouter au moins une image du bien'
      });
      return;
    }

    this.biens = {
      "name": this.biensImmob.name,
      "description": this.biensImmob.description,
      "prix": this.biensImmob.prix,  
      "agencyName": this.biensImmob.agencyName,   
      "categoryList": this.biensImmob.categoryList,  
      "imageUrl": this.allAttch.length > 0 ? this.allAttch[0] : '',   
      "promoTitle": this.biensImmob.promoTitle,
      "type": this.biensImmob.type,  
      "role": this.biensImmob.role,
      "videoUrlBien": this.biensImmob.videoUrlBien,  
      "promoImg": this.promoAttch.length > 0 ? this.promoAttch[0] : ''
    };

    console.log('Data to submit:', this.biens);

    this.bienImmobService.createBiensImmobs(this.biens).subscribe({
      next: () => {
        Swal.fire({
          icon: "success",
          title: "Succès",
          text: "Le bien immobilier a été créé avec succès",
        }).then(() => {
          this.clearStoredImages();
          setTimeout(() => {
            this.getData();
          }, 500);
          this.location.back();
        });
      },
      error: (error) => {
        console.error('Error creating property:', error);
        Swal.fire({
          icon: "error",
          title: "Erreur",
          text: "Échec de la création du bien immobilier. Veuillez réessayer.",
        });
      }
    });
  }

  onSubmit2(): void {
    if (this.validateForm()) {
      this.router.navigate([`listeBiensImmobs`]);
      console.log('Formulaire soumis avec succès');
      console.log(this.biensImmob);
    }
  }

  validateForm(): boolean {
    let isValid = true;

    // Validation pour le champ "name"
    if (!this.biensImmob.name) {
      this.nameErrorMessage = 'Le nom est requis !';
      isValid = false;
    } else if (!/^[a-zA-Z\s]{1,8}$/.test(this.biensImmob.name)) {
      this.nameErrorMessage = 'Le nom doit contenir uniquement des lettres et espaces (max 8 caractères)';
      isValid = false;
    } else {
      this.nameErrorMessage = '';
    }

    return isValid;
  }

  validateVideoUrl(): boolean {
    if (!this.biensImmob.videoUrlBien) return true; // Optional field
    
    const youtubeUrlPattern = /^(https?\:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return youtubeUrlPattern.test(this.biensImmob.videoUrlBien);
  }

  retrieveStoredItemId(): void {
    const storedItemId = localStorage.getItem('storedItemId');
    this.idItem = storedItemId;
    console.log(this.idItem);
  }

  AgencyNameById(): void {
    if (this.idItem) {
      this.agenciesService.getAgencieById(this.idItem).subscribe((data: any) => {
        this.NameAgence = data.name;
        console.log(this.NameAgence);
      });
    }
  }
}